'use strict';

module Patersons {

    export interface ForgottenPanScope extends ng.IScope {
        email: string;
        dob: string;
        forgottenPanForm: ng.IFormController;
        isTriggered: boolean;
        errorHandler: any;
        events: Patersons.ForgottenPanCtrl;
        isBusy: boolean;
    }

    export class ForgottenPanCtrl extends IdentityBaseCtrl {
        scope: Patersons.ForgottenPanScope;
        location: ng.ILocationService;
        window: ng.IWindowService;
        state: angular.ui.IStateService;
        stateParams: angular.ui.IStateProvider;
        http: ng.IHttpService;
        identityService: Patersons.IdentityService;
        tokenService: TokenService;
        response;

        static $inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'identityService', 'tokenService', 'navigationService'];

        constructor($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, identityService, tokenService, navigationService) {
          super($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.location = $location;
            this.window = $window;
            this.state = $state;
            this.stateParams = $stateParams;
            this.http = $http;
            this.identityService = identityService;
            this.tokenService = tokenService;

            this.scope.isBusy = false;

            this.scope.events = this;
            this.scope.isTriggered = false;
        }

        save() {
            this.scope.isTriggered = false;
            this.scope.$broadcast('show-errors-check-validity');

            if (this.scope.forgottenPanForm.$invalid) {
                return;
            } else {
                let dto: ForgottenPanDetails = new ForgottenPanDetails();
                dto.email = this.scope.email;
                dto.dob = moment.utc(this.scope.dob, "DD/MM/YYYY").toISOString();

                this.scope.isBusy = true;

                this.identityService.triggerForgottenPan(dto)
                    .then((result) => {
                        this.scope.isTriggered = true;
                        this.returnToLoginScreenIn(30);
                    })
                    .finally(() => {
                        this.scope.isBusy = false;
                    });
            }
        }

        returnToLoginScreenIn(nSeconds: number) {
            return new Promise(() => setTimeout(() => this.tokenService.tokenManager.redirectForToken(), nSeconds * 1000));
        }
    }
}
